<template>
  <div v-gxxt-loading="isLoadingMore">
    <div class="c-order-list" v-if="orderList.records.length>0">
      <list-item @click="clickItem" :item="item" v-for="item in orderList.records" :key="item.id"></list-item>
    </div>
    <gxxt-no-data v-if="!isLoadingMore && orderList.records.length==0" text="还没有订单哦～"></gxxt-no-data>
  </div>
</template>

<script>
import listItem from './components/list-item.vue'
import { GxxtNoData } from '@/components'
import {
  getAppScrollTop,
  getAppScrollHeight,
  getWindowHeight,
} from '@/utils/common'
export default {
  components: {
    listItem,
    GxxtNoData,
  },
  data() {
    return {
      orderList: {
        records: [],
        total: 0,
        ct: '',
      },
      userInfo: {},
      isLoadingMore: true,
      more: true,
    }
  },
  unmounted() {
    this.removeScroll()
  },
  async mounted() {
    await this.userLoginInfo()
    this.getOrderList()
    this.bindScroll()
  },
  methods: {
    async userLoginInfo() {
      let res = await this.api.login.userLoginInfo()
      if (res && res.code == 200) {
        this.userInfo = res.data
      }
    },
    async getOrderList({ more = false } = {}) {
      if (more && !this.more) return
      this.isLoadingMore = true
      let prev = '',
        ln = this.orderList.records.length
      prev =
        this.orderList.records[ln - 1] && this.orderList.records[ln - 1].ct
          ? this.orderList.records[ln - 1].ct
          : ''
      let res = await this.api.my.myOrderList({
        userId: this.userInfo.id,
        ct: more ? prev : '',
      })
      this.isLoadingMore = false
      if (res && res.code == 200) {
        if (more) {
          res.data.records.forEach((item) => {
            this.orderList.records.push(item)
          })
          this.orderList.ct = res.data.ct
        } else {
          this.orderList =
            res.data && res.data.records ? res.data : { records: [] }
        }
        if (!res.data.more) {
          this.more = false
        }
      }
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.isLoadingMore = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    scrollFun() {
      let timeAction
      if (this.isLoadingMore) {
        return
      }
      const callback = () => {
        var scrollTop = getAppScrollTop(),
          delta = scrollTop - this.beforeScrollTop
        this.beforeScrollTop = scrollTop
        if (
          delta > 0 &&
          scrollTop + getWindowHeight() + 100 > getAppScrollHeight()
        ) {
          this.loadMoreFn()
        }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
    loadMoreFn() {
      if (this.isLoadingMore || !this.more) {
        return false
      }
      this.getOrderList({ more: true })
    },
    jumpToGuide() {
      this.$router.push({
        name: 'download',
      })
    },
    clickItem(data) {
      if (this.origin != 'miniprogram') {
        this.$messageBox({
          title: '打开更新学堂App去查看订单',
          show: true,
          btnType: 2,
          cancelBtnText: '暂不查看',
          confirmBtnText: '去查看',
          origin: this.origin,
          showOpenApp: true,
          confirmCallback: () => {
            // 跳转app
            if (this.origin == 'miniprogram') {
              this.jumpToGuide()
            } else {
              this.openApp()
            }
          },
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
.c-order-list {
  min-height: 100%;
  background-color: #f7f7f7;
  padding: 20px 0 30px;
}
</style>